import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { ScrollToTopButton } from "@/components/ScrollToTopButton";
import Home from "@/pages/Home";

const Search = lazy(() => import("@/pages/Search"));
const PropertyDetail = lazy(() => import("@/pages/PropertyDetail"));
const Favorites = lazy(() => import("@/pages/Favorites"));
const Popular = lazy(() => import("@/pages/Popular"));
const Login = lazy(() => import("@/pages/Login"));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword"));
const Register = lazy(() => import("@/pages/Register"));
const Payments = lazy(() => import("@/pages/Payments"));

const RouteFallback = () => (
  <div className="w-full px-4 lg:px-8 py-10">
    <div className="h-96 rounded-xl bg-muted animate-pulse" />
  </div>
);

const HIDDEN_HEADER_ROUTES = ["/login", "/forgot-password", "/register"];

function AppContent() {
  const location = useLocation();
  const hideHeader = HIDDEN_HEADER_ROUTES.includes(location.pathname);

  return (
    <div className="App min-h-screen flex flex-col">
      {!hideHeader && <Header />}
      <main className="flex-1">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reels" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/detail/:propertyCode" element={<PropertyDetail />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/popular" element={<Popular />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payments" element={<Payments />} />
          </Routes>
        </Suspense>
      </main>
      <ScrollToTopButton />
      <Toaster closeButton position="top-right" />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;